import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import createHttpRequest from 'shared/api/http';

export const oauthInit = createAsyncThunk<{ url: string }, { provider: string }>(
    'auth/oauthInit',
    async({ provider }) => {
        const response = await createHttpRequest({
            method: 'GET',
            path: ApiUrls.OAUTH_INIT(provider),
            isAnonymous: true,
            errorMessage: t`Ошибка инициализации OAuth авторизации`,
        });
        return response.data;
    },
);
